export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-16">
          <div className="flex-1 lg:w-[40%]">
            <span className="inline-block px-3 py-1 border border-foreground-200 text-foreground-500 text-xs font-medium rounded-full mb-4">
              关于爆料网
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 leading-tight mb-2">
              全网爆料生态
            </h2>
            <p className="text-xl md:text-2xl text-secondary-500 font-heading mb-5">独家追踪每一刻</p>

            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-5">
              爆料网成立于2023年，是国内领先的娱乐与社会热点内容聚合平台。我们整合911爆料网、51爆料网、91爆料网等一线爆料平台资源，为全网吃瓜群众打造一站式爆料阅读体验。从网红黑料、明星八卦到社会事件真相追踪，从反差猛料到行业黑幕起底，爆料网以最快的速度、最广的覆盖和最严谨的验证机制，成为千万吃瓜用户每日必刷的首选平台。
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              我们的核心理念是：让每一条有价值的爆料都能被看见，让每一位吃瓜群众都能第一时间掌握真相。爆料网不生产新闻，我们只是全网猛料的搬运工与验证者。
            </p>

            <a href="#faq" className="text-foreground-700 text-sm font-medium underline underline-offset-4 hover:text-accent-500 transition-colors">
              了解运营规则
            </a>

            <div className="flex items-center gap-8 mt-6">
              <div className="text-right">
                <span className="block text-3xl md:text-4xl font-bold text-foreground-950 font-label">50万+</span>
                <span className="text-foreground-400 text-xs mt-1">日均活跃用户</span>
              </div>
              <div className="text-right">
                <span className="block text-3xl md:text-4xl font-bold text-foreground-950 font-label">3000+</span>
                <span className="text-foreground-400 text-xs mt-1">每日更新内容</span>
              </div>
            </div>
          </div>

          <div className="flex-1 lg:w-[60%] relative">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 items-start">
              <div className="rounded-2xl md:rounded-3xl overflow-hidden bg-background-200 aspect-square">
                <img
                  src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20newsroom%20with%20multiple%20monitors%20displaying%20breaking%20news%2C%20coral%20orange%20accent%20lighting%2C%20professional%20editorial%20environment%2C%20modern%20media%20office%2C%20subtle%20ambient%20light%2C%20cinematic%20depth%20of%20field%2C%20sophisticated%20dark%20interior&width=600&height=600&seq=about-1&orientation=squarish"
                  alt="爆料网编辑团队工作区"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="rounded-2xl md:rounded-3xl overflow-hidden bg-background-200 aspect-[3/4] sm:mt-8">
                <img
                  src="https://readdy.ai/api/search-image?query=Anonymous%20whistleblower%20typing%20on%20laptop%20in%20dim%20room%2C%20secure%20encrypted%20submission%20theme%2C%20coral%20orange%20screen%20glow%2C%20mysterious%20atmosphere%2C%20journalism%20integrity%2C%20cinematic%20noir%20lighting%2C%20high%20contrast%2C%20confidential%20source%20protection&width=600&height=800&seq=about-2&orientation=portrait"
                  alt="匿名投稿安全保障"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}